import { render } from "./smsSettings.vue?vue&type=template&id=09377d3d&scoped=true"
import script from "./smsSettings.vue?vue&type=script&lang=js"
export * from "./smsSettings.vue?vue&type=script&lang=js"

import "./smsSettings.vue?vue&type=style&index=0&id=09377d3d&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09377d3d"]])

export default __exports__